import { ITeam } from "./team";

export enum InvoiceStatus {
  PAID = 'paid',
  OPEN = 'open',
  OVERDUE = 'overdue',
  CANCELLED = 'cancelled',
}

export interface StripeInvoiceItems {
  localInvoiceItemId?: string;
  id?: string;
  customer: string;
  currency?: string;
  price: string;
  quantity: number;
  unit_amount: number;
  amount: number;
  description?: string;
}

export interface StripeInvoice {
  localInvoiceId?: string;
  id: string;
  customer: string;
  invoice_pdf?: string | null;
  issuer?: {
    type: string;
    account: string;
  };
  paid?: boolean;
  rendering_options?: object | null;
  hosted_invoice_url?: string
  status?: string;
  subscription?: string | null;
  description?: string;
  subtotal?: number;
  total?: number;
  collection_method: string;
  items: StripeInvoiceItems[]
}

export interface IInvoice {
  id?: number;
  seller_team: number;
  buyer_team: number;
  unit_price: number;
  quantity: number;
  amount?: number;
  discount_fixed?: number;
  discount_percent?: number;
  discount_type?: 'fixed' | 'percent';
  status: InvoiceStatus;
  created_at?: string;
  updated_at?: string;
  stripeInvoiceId?: string;
  hosted_invoice_url?: string;
  seller?: ITeam
  buyer?: ITeam
}